/*
 * @Description:
 * @Author: kangkang
 * @Date: 2022-06-23 23:24:11
 * @LastEditTime: 2023-04-11 00:36:27
 * @LastEditors: kangkang
 * @Reference:
 */
export default {
    getWxAuthorize: {
        method: "POST",
        url: "/api/auth/wxAuthorize",
        name: "微信授权接口"
    },
    getWxUserByCode: {
        method: "POST",
        url: "/api/auth/getWxUserByCode",
        name: "获取用户信息"
    },
    getDecryptData: {
        method: "POST",
        url: "/api/auth/decryptData",
        name: "解密二维码信息"
    },
    getToken: {
        method: "POST",
        url: "/api/auth/getToken",
        name: "获取token"
    },
    getRefreshToken: {
        method: "POST",
        url: "/api/auth/refreshToken",
        name: "刷新token"
    },
    audioList: {
        method: "POST",
        url: "/api/config/audioList ",
        name: "背景音乐列表接口"
    },
    getBackVideoList: {
        method: "POST",
        url: "/api/comm/getBackVideoList",
        name: "获取背景视屏列表"
    },
    uploadImage: {
        method: "POST",
        url: "/api/upload/image",
        name: "上传图片接口"
    },
    orderCreate: {
        method: "POST",
        url: "/api/order/create",
        name: "下单接口"
    },
    orderLists: {
        method: "POST",
        url:  "/api/order/lists",
        name: "我的订单列表接口"
    },
    orderConfirm: {
        method: "POST",
        url:  "/api/order/confirm",
        name: "我的订单确认接口"
    },
    payConfig: {
        method: "POST",
        url: "/api/pay/config",
        name: "微信支付签名接口"
    },
    orderLists: {
        method: "POST",
        url: "/api/order/lists",
        name: "我的订单列表接口"
    },
    orderConfirm: {
        method: "POST",
        url: "/api/order/confirm",
        name: "我的订单确认接口"
    },
    wxConfig: {
        method: "POST",
        url: "/api/wx/config",
        name: "微信JSSDK配置接口"
    },
    noPicStatus: {
        method: "POST",
        url:  "/api/order/notPicStatusList",
        name: "无照片模板列表"
    },
    videoTplList: {
        method: "POST",
        url: "/api/config/videoTplList",
        name: "背景列表接口"
    },
};
